let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3kHns"), load("3JzPO"), load("eacuJ")]).then(() => parcelRequire('bzo9I'));